import { attachDynamicEvent } from '~/common/helpers/dom'
import { processFormSubmission } from './common'

/*
  Paypal's process is started by the user's browser submitting to the payment provider's website. When the user submits
  the checkout, we generate a form, put it on page, then have the browser submit it. Then the payment processor handles
  everything else.

  There are no usable saved payment methods, so we only have to deal with new ones.
*/

function submitIfWithNewPaypal(event) {
  if (getSelectedPaypalProcessorOption()) {
    submitWithNewPaypal(event)
  }
}

async function submitWithNewPaypal(event) {
  event.preventDefault()

  let submitButton = event.target
  let form = submitButton.closest('form')

  processFormSubmission(form, {
    onSuccess: (json) => {
      if (json.redirect) {
        window.location.href = json.redirect
        return
      }
      const form = insertPaymentWindow(json.payment_window)
      form.target = '_top'
      form.submit()
    },
  })
}

// Unbalanced markup earlier on the page (a translation or a custom label with an unclosed tag) can leave
// #payment_window nested inside the checkout <form>. Setting innerHTML there makes the browser drop the nested
// <form>, so parse it in a detached template, which has no form ancestor, and move the nodes in.
function insertPaymentWindow(html) {
  let container = document.getElementById('payment_window')
  // Only pages that render the after-checkout-step content have #payment_window; don't depend on it.
  if (!container) {
    container = document.createElement('div')
    container.id = 'payment_window'
    document.body.appendChild(container)
  }

  const template = document.createElement('template')
  template.innerHTML = html
  container.textContent = ''
  container.appendChild(template.content)

  const form = container.querySelector('form')
  if (!form) throw new Error('PayPal payment form missing')

  return form
}

function getSelectedPaypalProcessorOption() {
  return document.querySelector(
    '.cart-checkout-payment .payment-processor-option-paypal input[type=radio]:checked, ' +
      ".cart-checkout-payment input[type=hidden][name='payment_method'].payment-processor-option-paypal"
  )
}

attachDynamicEvent(
  '.cart-checkout-payment .submit-payment',
  'click',
  submitIfWithNewPaypal
)
